var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResolveSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1L2.5 2.5L0.5 13L1 14L4 15L8 15.5L12 15L15 14L15.5 13L13.5 2L12 1L8 0.5L4 1Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7079 13.4195C14.4272 13.6683 13.964 13.9381 13.3057 14.185C11.9966 14.6759 10.121 15 8 15C5.87903 15 4.0034 14.6759 2.69427 14.185C2.03602 13.9381 1.57279 13.6683 1.29209 13.4195C1.01022 13.1696 1 13.0255 1 13C1 12.9745 1.01022 12.8304 1.29209 12.5805C1.57279 12.3317 2.03602 12.0619 2.69427 11.815C4.0034 11.3241 5.87903 11 8 11C10.121 11 11.9966 11.3241 13.3057 11.815C13.964 12.0619 14.4272 12.3317 14.7079 12.5805C14.9898 12.8304 15 12.9745 15 13C15 13.0255 14.9898 13.1696 14.7079 13.4195ZM8 16C12.4183 16 16 14.6569 16 13C16 11.3431 12.4183 10 8 10C3.58172 10 0 11.3431 0 13C0 14.6569 3.58172 16 8 16Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1V0H8.5V1H7.5ZM7.5 5V3H8.5V5H7.5ZM7.5 9V7H8.5V9H7.5ZM7.5 13V11H8.5V13H7.5ZM7.5 16V15H8.5V16H7.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0081 13.0895L13.0081 2.08947L13.9919 1.91058L15.9919 12.9106L15.0081 13.0895Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00805664 12.9106L2.00806 1.91058L2.99193 2.08947L0.991927 13.0895L0.00805664 12.9106Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2H8V13H15.5L13.5 2Z",
    fill: "#00C2FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9173 1.5H7.50001V13.5H16.0991L13.9173 1.5ZM13.0827 2.5L14.9009 12.5H8.50001V2.5H13.0827Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0259 1.8799C13.0261 1.87991 13.025 1.88214 13.0218 1.88654C13.0241 1.88209 13.0257 1.87988 13.0259 1.8799ZM12.9006 2C12.7206 2.13922 12.4031 2.30662 11.9264 2.46553C10.9675 2.78515 9.57928 3 8 3C6.42072 3 5.03245 2.78515 4.07359 2.46553C3.59686 2.30662 3.27937 2.13922 3.09935 2C3.27937 1.86078 3.59686 1.69338 4.07359 1.53447C5.03245 1.21485 6.42072 1 8 1C9.57928 1 10.9675 1.21485 11.9264 1.53447C12.4031 1.69338 12.7206 1.86078 12.9006 2ZM2.97412 1.8799C2.97434 1.87988 2.97592 1.88209 2.9782 1.88654C2.97504 1.88214 2.9739 1.87991 2.97412 1.8799ZM2.97412 2.1201C2.9739 2.12009 2.97504 2.11786 2.9782 2.11346C2.97592 2.11791 2.97433 2.12012 2.97412 2.1201ZM13.0218 2.11346C13.025 2.11786 13.0261 2.12009 13.0259 2.1201C13.0257 2.12012 13.0241 2.11791 13.0218 2.11346ZM8 4C11.3137 4 14 3.10457 14 2C14 0.895431 11.3137 0 8 0C4.68629 0 2 0.895431 2 2C2 3.10457 4.68629 4 8 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolveSolid);
export default __webpack_public_path__ + "static/media/resolve-solid.10a68fe2ddaa918825d924f2960bbd0d.svg";
export { ForwardRef as ReactComponent };